import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const PRICE_OVERRIDE_REASONS = [
  "Shelf price differs",
  "Damaged / shop-soiled item",
  "Price match",
  "Manager approved",
  "Wrong price in system",
  "Bulk / negotiated price",
];

export const PriceOverrideReasonDialog = ({ pending, onConfirm, onCancel }) => {
  const [reason, setReason] = useState("");
  const [other, setOther] = useState("");

  useEffect(() => { setReason(""); setOther(""); }, [pending]);

  const finalReason = reason === "Other" ? other.trim() : reason;
  const submit = () => finalReason && onConfirm(finalReason);

  return (
    <Dialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent
        className="max-w-md"
        data-testid="price-override-reason-dialog"
        onOpenAutoFocus={(e) => e.preventDefault()}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); submit(); } }}
      >
        <DialogHeader>
          <DialogTitle>Why is the price lower?</DialogTitle>
        </DialogHeader>
        {pending && (
          <p className="text-sm text-slate-600" data-testid="price-override-summary">
            <span className="font-semibold">{pending.name}</span>: R {pending.oldPrice.toFixed(2)} → <span className="font-bold text-red-600">R {pending.newPrice.toFixed(2)}</span>
          </p>
        )}
        <div className="grid grid-cols-2 gap-2">
          {[...PRICE_OVERRIDE_REASONS, "Other"].map((r, i) => (
            <button
              key={r}
              type="button"
              onClick={() => setReason(r)}
              className={`text-left text-sm rounded border px-3 py-2 transition-colors ${reason === r ? "border-blue-600 bg-blue-50 font-semibold text-blue-800" : "border-slate-200 hover:bg-slate-50"}`}
              data-testid={`price-override-reason-${i}`}
            >
              {r}
            </button>
          ))}
        </div>
        {reason === "Other" && (
          <Input
            autoFocus
            autoCapitalize={false}
            value={other}
            onChange={(e) => setOther(e.target.value)}
            placeholder="Type the reason..."
            data-testid="price-override-other-input"
          />
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="price-override-cancel">Keep old price</Button>
          <Button onClick={submit} disabled={!finalReason} data-testid="price-override-confirm">Change price</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
